import { render } from "./RegisterDeliveryApp.vue?vue&type=template&id=0e43d16c"
import script from "./RegisterDeliveryApp.vue?vue&type=script&lang=js"
export * from "./RegisterDeliveryApp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__